import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getDemoBookingConfig, saveDemoBookingConfig } from '@/services/demoBooking';

export const useGetDemoBookingConfig = (chatToken: string) => {
  return useQuery({
    queryKey: ['demo-booking-config', chatToken],
    queryFn: () => getDemoBookingConfig(chatToken),
    enabled: !!chatToken,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useSaveDemoBookingConfig = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: saveDemoBookingConfig,
    onSuccess: (data, variables) => {
      // Invalidate and refetch the demo booking config
      queryClient.invalidateQueries({
        queryKey: ['demo-booking-config', variables.chatToken],
      });
    },
  });
};